
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curated-collections",
      function () {
        return require("private-next-pages/curated-collections.js");
      }
    ]);
  